import type { InputTextPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum InputSize {
  SMALL = 'small',
  LARGE = 'large',
}

export enum InputIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum InputState {
  SUCCESS = 'success',
  ERROR = 'error',
  DISABLED = 'disabled',
}

export type PassThroughMeridiaInput =
  PassThrough<InputTextPassThroughOptions> & {
    wrapper?: { class: string };
    helper_text?: { class: string };
    icon?: { class?: string; [key: string]: any };
    clearIcon?: { class: string };
  };
